import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import HubspotForm from 'react-hubspot-form'
import ReactMarkdown from 'react-markdown'
import Vimeo from '@u-wave/react-vimeo'
import MetaHeaders from '../../components/metaheaders'
import Layout from '../../components/layout'
import { DEMO_CONTENTFUL_ID } from '../../utils/vars'
import ContentfulClient from '../../contentful'

import styles from './MeetStich.module.scss'

const MeetStich = ({
    metaTitle,
    metaDescription,
    title,
    description,
    videoUrl,
    hubSpotFormTitle,
    hubSpotPortalId,
    hubSpotFormId,
}) => {
    const [expanded, setExpanded] = useState(false)
    const videoRef = useRef(null)

    return (
        <div className={styles.meetStich}>
            <MetaHeaders title={metaTitle} description={metaDescription} />
            <Layout>
                <div className={`${styles.infoContainer} container`}>
                    <h1 className={styles.infoTitle}>{title}</h1>
                    <ReactMarkdown className="info-description" source={description} />
                </div>
                <div ref={videoRef} className={`container ${styles.videoContainer} ${expanded ? ' expanded' : ''}`}>
                    <Vimeo
                        video={videoUrl}
                        responsive
                        onPlay={() => {
                            videoRef.current.scrollIntoView({ behavior: 'smooth' })
                            setExpanded(true)
                        }}
                    />
                </div>
                <div className={`container ${styles.hubspotForm}`}>
                    <h2 className={styles.hubspotTitle}>{hubSpotFormTitle}</h2>
                    <HubspotForm
                        className={styles.mainForm}
                        portalId={hubSpotPortalId}
                        formId={hubSpotFormId}
                    />
                </div>
            </Layout>
        </div>
    )
}

MeetStich.propTypes = {
    metaTitle: PropTypes.string.isRequired,
    metaDescription: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    videoUrl: PropTypes.string.isRequired,
    hubSpotFormTitle: PropTypes.string.isRequired,
    hubSpotPortalId: PropTypes.string.isRequired,
    hubSpotFormId: PropTypes.string.isRequired,
}

MeetStich.getInitialProps = async () => {
    const res = await ContentfulClient.getEntry(DEMO_CONTENTFUL_ID)
    return res.fields
}

export default MeetStich
